import StarIcon from '@wwt/shared/assets/icons/outline/star.svg'

import { cn } from '@/shared/lib/cn'

export interface RatingOrHotelTypeProps {
	/**
	 * Stars
	 * - min: -1
	 * - default: -1
	 * - max: 5
	 */
	stars: number
	hotelType: string
	starClassName?: string
}

export const RatingOrHotelType = ({
	stars = -1,
	hotelType,
	starClassName
}: RatingOrHotelTypeProps) => {
	const isRating = stars !== -1
	const starsForShow = isRating
		? Array.from({ length: stars }, (_, i) => i)
		: []

	return (
		<span className="flex min-w-fit flex-row">
			{isRating ? (
				starsForShow.map(i => (
					<span
						key={i}
						className={cn(
							'flex size-[1.5rem] items-center justify-center',
							starClassName
						)}
					>
						<StarIcon />
					</span>
				))
			) : (
				<span>{hotelType}</span>
			)}
		</span>
	)
}
